import React, { FC } from 'react';

import { useHeader } from '../components/common/navigation/hooks/header-service';

const EquipmentsMapPage: FC = () => {
  useHeader('Локации оборудования', []);

  return (
    <>
    </>
  );
};

export default EquipmentsMapPage;
